import { createApi } from '@reduxjs/toolkit/query/react';
import { createApiConfig } from '../createApiConfig';

export const UtilsApi = createApi({
  reducerPath: 'UtilsApi',
  ...createApiConfig(process.env.REACT_APP_API_BASE_URL),
  tagTypes: ['Country', 'Language', 'GuacamoleSession'],
  endpoints: (builder) => ({
    listCountry: builder.query({
      query: (params) => ({
        url: `/utils/countries/`,
        params,
      }),
      
      providesTags: ['Country'],
    }),

    createCountry: builder.mutation({
      query: (data) => ({
        url: `/utils/countries/`,
        method: 'POST',
        body: data,
      }),
      
      invalidatesTags: ['Country'],
    }),

    updateCountry: builder.mutation({
      query: ({ id, data }) => ({
        url: `/utils/countries/${id}/`,
        method: 'PATCH',
        body: data,
      }),
      
      invalidatesTags: ['Country'],
    }),


    listLanguage: builder.query({
      query: (params) => ({
        url: `/utils/languages/`,
        params,
      }),
      
      providesTags: ['Language'],
    }),

    createLanguage: builder.mutation({
      query: (data) => ({
        url: `/utils/languages/`,
        method: 'POST',
        body: data,
      }),
      
      invalidatesTags: ['Language'],
    }),

    updateLanguage: builder.mutation({
      query: ({ id, data }) => ({
        url: `/utils/languages/${id}/`,
        method: 'PATCH',
        body: data,
      }),
      
      invalidatesTags: ['Language'],
    }),

    createGuacamoleSession: builder.mutation({
      query: (data) => ({
        url: `/utils/guacamole/session/`,
        method: 'POST',
        body: data,
      }),
      invalidatesTags: ['GuacamoleSession'],
    }),
  }),
});

export const {
  // Countries
  useListCountryQuery,
  useCreateCountryMutation,
  useUpdateCountryMutation,

  // Languages
  useListLanguageQuery,
  useCreateLanguageMutation,
  useUpdateLanguageMutation,

  // Guacamole
  useCreateGuacamoleSessionMutation,
} = UtilsApi;
